module.exports = __webpack_public_path__ + "img/2.1.4cde0651.jpg";